import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import type { IRaangeLabelProps } from "src/shared/components/RaangeLabel";
import RaangeLabel from "src/shared/components/RaangeLabel";
import type ILinkable from "src/shared/formatters/ILinkable";
import {
  GetEditUserViewPath,
  USERS_LIST_PATH,
} from "src/users/views/UsersPaths";
import type { User } from "src/users/objects/User";

export interface IUsersLabelProps
  extends Omit<IRaangeLabelProps, "fa">,
    ILinkable {}

export const UsersLabel = (props: IUsersLabelProps) => {
  const { hasLink = false } = props;
  const label = (
    <RaangeLabel fa="list-alt" {...props}>
      <FormattedMessage id="users" />
    </RaangeLabel>
  );
  if (hasLink) {
    return <Link to={USERS_LIST_PATH}>{label}</Link>;
  } else {
    return label;
  }
};
export const UserCreate = (props: Omit<IRaangeLabelProps, "fa">) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="users.create" />
    </RaangeLabel>
  );
};
export const UserEdit = (
  props: IUserFormatterProps & ILinkable & Omit<IRaangeLabelProps, "fa">,
) => {
  const { hasLink = false, children, ...rest } = props;
  const reactNode = (
    <RaangeLabel fa="pencil-alt" {...rest}>
      <FormattedMessage id="users.edit" />
    </RaangeLabel>
  );

  if (hasLink) {
    return <Link to={GetEditUserViewPath(children)}>{reactNode}</Link>;
  } else {
    return <span>{reactNode}</span>;
  }
};

export interface IUserFormatterProps extends Omit<IRaangeLabelProps, "fa"> {
  children: User;
}

export const UserStatus = (props: IUserFormatterProps) => {
  const { children: user } = props;
  if (user.status) {
    return <FormattedMessage id="users.status.active" />;
  } else {
    return <FormattedMessage id="users.status.inactive" />;
  }
};
